import React from 'react';

function Zillow() {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="15" 
            height="16" 
            viewBox="0 0 15 16" 
            fill="none"
        >
            <path 
                d="M4.04523 14.2034C3.98273 14.2359 3.93184 14.2278 3.88159 14.179L2.48293 12.5607C2.44556 12.5156 2.44105 12.4912 2.4913 12.4224C3.57235 10.8854 5.77889 8.49013 7.18593 7.47797C7.21106 7.4617 7.20268 7.44106 7.17304 7.45357C5.70738 7.91711 1.54104 9.65743 0 10.5032V16H14.9961V10.7065C12.9526 11.0437 6.83031 12.8128 4.04523 14.2034ZM10.1424 4.3145C10.2178 4.29824 10.2513 4.32263 10.297 4.37143C10.5566 4.65168 11.3864 5.63569 11.6119 5.90405C11.6538 5.95285 11.6248 6.00602 11.5913 6.03417C9.91625 7.30281 8.05244 9.10005 7.01392 10.385C6.9933 10.4137 7.01005 10.4137 7.0268 10.4094C8.83585 9.65305 13.0859 8.44509 15 8.10791V5.75392L7.5087 0L0.00450973 5.74954V8.3231C2.32831 6.9819 7.70519 4.90378 10.1424 4.3145Z" 
                fill="#006AFF"
            />
        </svg>
    )
};

export default Zillow;